import { render, staticRenderFns } from "./time-btns.vue?vue&type=template&id=4d6810fc"
import script from "./time-btns.vue?vue&type=script&lang=js"
export * from "./time-btns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports